exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "button.menuButton {\n  margin-left:4em;\n  font-size: 60%;\n  border-radius: 15px;\n  cursor: pointer;\n  outline: none;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/project-summary/project-summary.component.css
// module id = 400
// module chunks = 0